import { render, staticRenderFns } from "./BigOccupationArea.vue?vue&type=template&id=ad2d1692"
import script from "./BigOccupationArea.vue?vue&type=script&lang=js"
export * from "./BigOccupationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2d1692')) {
      api.createRecord('ad2d1692', component.options)
    } else {
      api.reload('ad2d1692', component.options)
    }
    module.hot.accept("./BigOccupationArea.vue?vue&type=template&id=ad2d1692", function () {
      api.rerender('ad2d1692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/BigOccupationArea.vue"
export default component.exports